import permissions from '../permission-list'

export default [
  {
    path: '/v2/brands',
    name: 'brands-v2',
    component: () => import('@/views/v2/Brands.vue'),
    meta: {
      pageTitle: 'Daftar Brand',
      resource: permissions.brandV2,
      action: 'read',
      navActiveLink: 'brands-v2',
      localstorage: {
        query: 'brands-v2-query',
      },
      breadcrumb: [
        { text: 'Brand', active: true },
      ],
    },
  },
  {
    path: '/v2/brands/create',
    name: 'brands-v2-create',
    component: () => import('@/views/v2/BrandCreate.vue'),
    meta: {
      pageTitle: 'Buat Brand',
      resource: permissions.brandV2,
      action: 'manage',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        { text: 'Brand', to: { name: 'brands-v2' } },
        { text: 'Buat', active: true },
      ],
    },
  },
  {
    path: '/v2/brands/:id/edit',
    name: 'brands-v2-edit',
    component: () => import('@/views/v2/BrandEdit.vue'),
    meta: {
      pageTitle: 'Edit Brand',
      resource: permissions.brandV2,
      action: 'manage',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        { text: 'Brand', to: { name: 'brands-v2' } },
        { text: 'Edit', active: true },
      ],
    },
  },
  {
    path: '/v2/brands/:id/detail',
    name: 'brands-v2-detail',
    component: () => import('@/views/v2/BrandDetail.vue'),
    meta: {
      pageTitle: 'Detail Brand',
      resource: permissions.brandV2,
      action: 'read',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        { text: 'Brand', to: { name: 'brands-v2' } },
        { text: 'Detail', active: true },
      ],
    },
  },
  {
    path: '/v2/brands/:id/address',
    name: 'brands-v2-address',
    component: () => import('@/views/v2/BrandAddress.vue'),
    meta: {
      pageTitle: 'Alamat Brand',
      resource: permissions.brandV2,
      action: 'manage',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        { text: 'Brand', to: { name: 'brands-v2' } },
        { text: 'Alamat', active: true },
      ],
    },
  },
  {
    path: '/v2/brands/:id/couriers',
    name: 'brands-v2-couriers',
    component: () => import('@/views/v2/BrandCouriers.vue'),
    meta: {
      pageTitle: 'Kurir Brand',
      resource: permissions.brandV2,
      action: 'manage',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        { text: 'Brand', to: { name: 'brands-v2' } },
        { text: 'Kurir', active: true },
      ],
    },
  },
  {
    path: '/v2/brands/:id/pickup',
    name: 'brands-v2-pickup',
    component: () => import('@/views/v2/BrandPickup.vue'),
    meta: {
      pageTitle: 'Pickup Brand',
      resource: permissions.brandV2,
      action: 'manage',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        { text: 'Brand', to: { name: 'brands-v2' } },
        { text: 'Pickup', active: true },
      ],
    },
  },
]
